export enum Tenant {
    mh = 'mh'
  }

export type TenantStrings = keyof typeof Tenant
